module.exports = __webpack_public_path__ + "img/humons2.fc98e40e.jpg";